import React from 'react'
import { useNavigate } from 'react-router'
import { ICONS } from '@Const/common'
import RequireFeatureFlag from '@Components/Utility/RequireFeatureFlag'

interface RequestUpdateSharesButtonProps {
    to: string
}

const RequestUpdateSharesButton = ({ to }: RequestUpdateSharesButtonProps) => {
    const navigate = useNavigate()

    const openShareUpdateRequest = (event: React.MouseEvent | React.KeyboardEvent) => {
        event.preventDefault()
        event.stopPropagation()
        navigate(to)
    }

    return (
        <RequireFeatureFlag flagKey="songwriter-update-shares">
            <span
                role="button"
                tabIndex={0}
                className="songwriter-update-shares-link"
                onClick={openShareUpdateRequest}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        openShareUpdateRequest(event)
                    }
                }}
            >
                <img src={ICONS.flag} alt="" aria-hidden />
                <span>Request to Update Shares</span>
            </span>
        </RequireFeatureFlag>
    )
}

export default RequestUpdateSharesButton
